// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CountriesList from '../../constants/CountriesList';

// -- views
import LocalizableSelect from './LocalizableSelect';

class CountryChooser extends Component {

  static defaultProps = {
    clearable: false,

    readOnly: false
  };

  static propTypes = {
    // 'FR' for example
    country: PropTypes.string.isRequired,

    // param: String (Country code 'FR' for example.)
    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool,

    readOnly: PropTypes.bool
  };

  onChange = (option) => {
    if (_.isNull(option)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(option.value);
    }
  };

  render() {
    const options = CountriesList.getCountriesListForPicker();

    return (
      <div className="country_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.country}
          options={options}
          onChange={this.onChange}
          clearable={this.props.clearable}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }

}

export default CountryChooser;
